export default function Footer() {
  return (
    <footer style={{
      borderTop: "1px solid #1e293b", background: "#020617",
      padding: "1rem 1.5rem", display: "flex", justifyContent: "space-between",
      alignItems: "center", flexWrap: "wrap", gap: ".5rem",
      fontSize: ".7rem", color: "#475569"
    }}>
      <div>&copy; 2026 <span style={{ color: "#64748b", fontWeight: 600, letterSpacing: ".05em" }}>IHRD PMD System Architecture</span>. All Rights Reserved.</div>
      <div style={{ textTransform: "uppercase", letterSpacing: ".15em", fontWeight: 700, fontSize: ".6rem", color: "rgba(6,182,212,.6)" }}>
        designed and developed by ihrd pmdtvm 2026
      </div>
    </footer>
  );
}
